export default "__VITE_ASSET__hTVpnKCD__"